import { Checkbox } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import useFetch from '../hooks/useFetch'
import { getCurrentSubscriptionPrices, postUpgradeSubscription } from '../config/apiRoutes'
import { SubscriptionPlanPrice } from '../models/SubscriptionPlanPrice'
import UserContext from '../contexts/UserContext'
import { useTranslation } from 'react-i18next'
import { subscriptionPageRoute } from '../config/pageRoutes'

type Props = {}

const SubScriptionSettings = (props: Props) => {
    const { call } = useFetch();
    const { t, i18n } = useTranslation();
    const { currentSubscription } = useContext(UserContext);
    const [availablePlans, setAvailablePlans] = useState<string[]>([]);
    const [prices, setPrices] = useState<SubscriptionPlanPrice[]>([]);
    const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
    const [selectedPrice, setSelectedPrice] = useState<SubscriptionPlanPrice | null>(null);

    //https://e26a30c9-f0c1-4007-83aa-5ea7833da798.mock.pstmn.io

    useEffect(() => {
        fetchSubscriptionPlans();
    }, []);

    async function fetchSubscriptionPlans() {
        const response = await call<any, SubscriptionPlanPrice[]>("GET", getCurrentSubscriptionPrices);
        if (response.ok && response.data) {
            setPrices(response.data);
            const availablePlans = new Set(response.data.map(price => price.planId));
            setAvailablePlans(Array.from(availablePlans));
        }
    }

    useEffect(() => {
        if (currentSubscription != null) {
            setSelectedPlan(currentSubscription.subscriptionPlanId);
        }
    }, [currentSubscription]);

    useEffect(() => {
        if (currentSubscription == null) return;
        if (prices.length === 0) return;
        const match = prices.find(price => price.planId === currentSubscription.subscriptionPlanId && price.interval == currentSubscription.paymentInterval);
        if (match) {
            setSelectedPrice(match);
        }
    }, [prices, currentSubscription]);

    async function onPaymentUpgradeClick() {
        if (selectedPrice == null) return;
        const page = subscriptionPageRoute.path.replace(":lang", i18n.language) + `?price_id=${selectedPrice.id}`;
        window.location.href = page;
    }



    return (
        <div>
            <div>
                {availablePlans.map(plan => (
                    <div key={plan}>
                        <label>
                            <input
                                type="radio"
                                value={plan}
                                checked={selectedPlan === plan}
                                onChange={() => setSelectedPlan(plan)}
                            />
                            {plan}
                        </label>
                    </div>
                ))}
            </div>
            <div>
                {prices.map(price => (
                    <div key={price.id}>
                        <label>
                            <input
                                type="radio"
                                value={price.planId}
                                checked={selectedPrice?.id === price.id}
                                onChange={() => setSelectedPrice(price)}
                            />
                            {`${price.planId} - ${price.interval} - ${price.priceGross} HUF`}
                        </label>
                    </div>
                ))}
            </div>
            <button
                onClick={onPaymentUpgradeClick}>
                Csomag kiválasztása
            </button>
            <div>
                <button>
                    Lemondás
                </button>
            </div>
        </div>
    )
}

export default SubScriptionSettings